import React, { useState, useEffect, FC, useMemo } from 'react';
import './activity-table.scss';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import ShopTableRow from '../activity-table-row/activity-table-row';
import UserTableRow from '../activity-table-row/activity-table-row';
import { useSelector } from 'react-redux';
import ActivityTableRow from '../activity-table-row/activity-table-row';
export enum UserStatus{
    ACTIVE = 'Active',
    NOT_ACTIVE = 'Not active'
}
export enum UserPosition{
    MANAGER = 'Manager',
    EMPLOYEE = 'Employee'
}
export enum UserPermissions {
    EMPLOYEE = 'Employee',
    MANAGER = 'Manager',
    SUPER_MANAGER = 'Super manager',
    QOLAIG = 'Qolaig'
}

const ActivityTable = (props) => {
    const [search, setSearch] = useState('');
    const activityLog = useSelector((state: any) => state.shop.activityLog);
    const [checkedStocks, setCheckedStocks] = useState([]);
    const users = useSelector((state: any) => state.user.users)
    const shops = useSelector((state: any) => state.shop.shops)
    const userIdToName = useMemo(() => {
        return users.reduce((acc, user) => {
            acc[user.user_id] = user.name;
            return acc;
        }, {});
        
    }, [users]);

    const shopIdToName = useMemo(() => {
        console.log(shops)
        return shops.reduce((acc, shop) => {
            acc[shop.id] = shop.name;
            return acc;
        }, {});
    }, [shops]);
    console.log({userIdToName})
    const allChecked = checkedStocks.length === activityLog.length && activityLog.length;
    const setAllChecked = (checked: boolean) => {
        if(checked)
            setCheckedStocks(activityLog.map(stock => stock.id));
        else
            setCheckedStocks([]);
    }
    const setChecked = (checked: boolean, id: string) => {
        if(checked)
            setCheckedStocks([...checkedStocks, id]);
        else
            setCheckedStocks(checkedStocks.filter(stockId => stockId !== id));
    }
    const activityRow = useMemo(() => {
        return activityLog.map((activity) => {
            const userName = userIdToName[activity.user_id]?? 'Unknown';
            const shopName = shopIdToName[activity.shop_id]?? 'Unknown';
            return (
                <ActivityTableRow key={activity.id} {...activity} checked={checkedStocks.includes(activity.id)} setChecked={(checked, id)=>setChecked(checked, id)} username={userName} shopName={shopName}/>
            )
        })
    }, [activityLog, userIdToName, shopIdToName])
    return (
        <div className="activity-table">
            <div className="activity-table__upper">
                {/* <span>Edit columns</span>
                <div className="activity-table__upper__controls">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText placeholder="Search..." className="activity-table__upper__controls__filter-button" onChange={(e)=>setSearch(e.target.value)} />
                    </IconField>
                </div> */}
           </div>
            <div className="activity-table__table">
                <div className="activity-table__table__header">
                    <Checkbox onChange={e => setAllChecked(e.checked)} checked={allChecked}></Checkbox>
                    <div>Users</div>
                    <div>Shop</div>
                    <div>Product</div>
                    <div>Quantity (Liters)</div>
                    <div>Date</div>
                </div>
                <div className="activity-table__table__body">
                    {activityRow}
                </div>
            </div>

        </div>
    );
}
         
export default ActivityTable;